// Auto-generated from GTFS – do not edit manually
// Generated: 2026-05-20T11:20:58.946Z

export const STOP_COORDINATES = {
  AC035: [45.54089399, 8.852507],
  AC127: [45.534846, 8.84851899],
  AC128: [45.533787, 8.84850099],
  AC625: [45.54117599, 8.85257999],
  AC627: [45.54221499, 8.85572099],
  AC628: [45.54238399, 8.85599299],
  AC802: [45.545396, 8.850411],
  AC809: [45.545211, 8.85043],
  AC811: [45.53743599, 8.849568],
  AL028: [45.49106, 8.942463],
  AL029: [45.50488999, 8.94635199],
  AL040: [45.505427, 8.93681099],
  AL050: [45.50544, 8.958846],
  AL051: [45.50527599, 8.95902899],
  AL185: [45.50566399, 8.94726699],
  AL195: [45.505695, 8.94706899],
  AL196: [45.506517, 8.93662699],
  AL201: [45.505144, 8.94662899],
  AL501: [45.50518, 8.941942],
  AL801: [45.50527607, 8.93611601],
  AL802: [45.50452414, 8.93600872],
  AR999: [45.56157899, 9.053008],
  BA005: [45.48564099, 8.99694399],
  BA008: [45.48577099, 8.99669],
  BA019: [45.485469, 9.007261],
  BA029: [45.48561699, 9.006873],
  BC211: [45.54130599, 8.81477699],
  BC250: [45.541432, 8.814439],
  BC801: [45.54221199, 8.807412],
  BC802: [45.542152, 8.807336],
  BE010: [45.493441, 8.82816299],
  BE011: [45.49054899, 8.82539099],
  BE012: [45.48476099, 8.81962699],
  BE013: [45.479172, 8.816647],
  BE014: [45.47901499, 8.81964399],
  BE503: [45.479979, 8.81668199],
  BE504: [45.48457599, 8.81956599],
  BE505: [45.49042199, 8.825526],
  BE506: [45.493816, 8.82782899],
  BF285: [45.46914299, 8.83275099],
  BF295: [45.46826699, 8.834225],
  BF305: [45.468614, 8.83437199],
  BF306: [45.469231, 8.83255099],
  BI101: [45.57686799, 8.81629299],
  BI102: [45.577107, 8.81629199],
  BR001: [45.542993, 9.01022299],
  BR011: [45.54259999, 9.011984],
  BR023: [45.54819299, 9.01354099],
  BR033: [45.54437599, 9.01292299],
  BR042: [45.55038099, 9.01766799],
  BR044: [45.546467, 9.011788],
  BR072: [45.550231, 9.01753099],
  BR073: [45.54801899, 9.01329999],
  BR074: [45.543086, 9.011357],
  BR083: [45.546073, 9.011237],
  BR084: [45.54446599, 9.012922],
  BS001: [45.61234699, 8.859873],
  BS003: [45.61128299, 8.854565],
  BS011: [45.61049, 8.85422],
  BS027: [45.60843799, 8.858852],
  BS057: [45.618997, 8.85322599],
  BS071: [45.63459999, 8.82517999],
  BS085: [45.61434399, 8.851583],
  BS087: [45.58934199, 8.85837899],
  BS090: [45.615326, 8.86457499],
  BS118: [45.581203, 8.856384],
  BS212: [45.62145299, 8.847297],
  BS451: [45.58954199, 8.858636],
  BS452: [45.60835, 8.85323999],
  BS455: [45.598604, 8.86115999],
  BS456: [45.59874899, 8.860881],
  BS555: [45.58119599, 8.85642599],
  BT205: [45.547761, 8.88017],
  BT211: [45.543247, 8.895548],
  BT215: [45.543353, 8.895797],
  BT300: [45.543496, 8.88722999],
  BT301: [45.548393, 8.880205],
  BT400: [45.543265, 8.887439],
  BT701: [45.552291, 8.885087],
  BT702: [45.550522, 8.88136999],
  BT703: [45.54943, 8.882351],
  BT704: [45.55223399, 8.885462],
  BT775: [45.54432399, 8.87909599],
  BT776: [45.544096, 8.87850299],
  BT947: [45.54861899, 8.88046099],
  BT949: [45.55108999, 8.876697],
  BT951: [45.55091, 8.87693],
  BT956: [45.547873, 8.87976499],
  BT999: [45.55412299, 8.87332],
  CB021: [45.47215699, 8.91095299],
  CB022: [45.479144, 8.936743],
  CB023: [45.479053, 8.935966],
  CB053: [45.48076, 8.91071999],
  CB080: [45.480794, 8.910548],
  CB088: [45.46958999, 8.91847],
  CB098: [45.474013, 8.91748899],
  CB099: [45.46916799, 8.92054699],
  CB111: [45.46963999, 8.91841],
  CD071: [45.48724999, 9.01525999],
  CD072: [45.48931, 9.028682],
  CD074: [45.48732799, 9.014962],
  CD079: [45.489399, 9.028533],
  CD081: [45.488905, 9.024127],
  CD150: [45.50245499, 9.028586],
  CD155: [45.502635, 9.028588],
  CD160: [45.500013, 9.03077],
  CD166: [45.50034799, 9.03067899],
  CD901: [45.490013, 9.03682499],
  CD910: [45.48993999, 9.035244],
  CG111: [45.499469, 8.794299],
  CG143: [45.50684299, 8.817023],
  CG149: [45.51068799, 8.81230199],
  CG150: [45.506373, 8.81568799],
  CG178: [45.510387, 8.81335099],
  CG190: [45.50862699, 8.820857],
  CG250: [45.50557999, 8.8208],
  CG251: [45.505541, 8.822141],
  CG511: [45.49953199, 8.79421599],
  CG702: [45.512137, 8.81472499],
  CG998: [45.514984, 8.810442],
  CG999: [45.51431399, 8.810707],
  CL001: [45.578811, 8.97935399],
  CL002: [45.57470812, 8.98297552],
  CL005: [45.57793999, 8.979683],
  CL011: [45.57884499, 8.97949099],
  CL012: [45.57471899, 8.98312699],
  CN001: [45.570479, 8.92378899],
  CN002: [45.56913999, 8.92546299],
  CN006: [45.56448, 8.933377],
  CN016: [45.56443999, 8.93353699],
  CN017: [45.56923999, 8.92555599],
  CN018: [45.57050899, 8.924031],
  CN103: [45.56511099, 8.92239],
  CN104: [45.562832, 8.91778499],
  CN105: [45.564988, 8.922245],
  CN118: [45.56752099, 8.929918],
  CN218: [45.56679399, 8.93050499],
  CR001: [45.59033399, 8.948978],
  CR002: [45.59236399, 8.947187],
  CR003: [45.59431899, 8.94918699],
  CR004: [45.592919, 8.951495],
  CR005: [45.591293, 8.95330399],
  CR006: [45.59133, 8.95730099],
  CR007: [45.59052199, 8.96121699],
  CR008: [45.58723999, 8.967316],
  CR015: [45.59507299, 8.95320999],
  CR022: [45.592348, 8.94693],
  CR033: [45.594292, 8.94902299],
  CR066: [45.591476, 8.957389],
  CR077: [45.58918299, 8.96324399],
  CR080: [45.59386899, 8.94132599],
  CR088: [45.58724999, 8.967756],
  CR089: [45.59401, 8.941321],
  CT001: [45.54764999, 8.788244],
  CT011: [45.547631, 8.78835799],
  CT021: [45.548836, 8.790655],
  CT027: [45.548641, 8.790828],
  CT050: [45.55215199, 8.783293],
  CT100: [45.555196, 8.772476],
  CT110: [45.553532, 8.78285099],
  CZ010: [45.527642, 8.900764],
  CZ070: [45.518269, 8.90386899],
  CZ080: [45.526413, 8.901723],
  CZ088: [45.52430699, 8.90558],
  CZ093: [45.51737699, 8.904693],
  CZ094: [45.522808, 8.90583],
  CZ097: [45.524346, 8.906963],
  DG097: [45.56490199, 8.866352],
  DG099: [45.56440499, 8.866728],
  DG141: [45.568466, 8.86506499],
  DG142: [45.569229, 8.86450799],
  DG801: [45.566804, 8.85991599],
  DG807: [45.56578599, 8.85901699],
  GB038: [45.555829, 8.998403],
  IN127: [45.51866899, 8.852296],
  IN128: [45.518854, 8.85180799],
  IN235: [45.51128799, 8.85305],
  IN275: [45.51096699, 8.85195899],
  IN285: [45.511039, 8.83897599],
  IN350: [45.511978, 8.859232],
  IN351: [45.512179, 8.859106],
  IN375: [45.514911, 8.880727],
  IN401: [45.508822, 8.87701599],
  IN402: [45.509048, 8.877107],
  IN403: [45.510946, 8.83778599],
  IN433: [45.51500299, 8.87987399],
  IN801: [45.511496, 8.842311],
  IN802: [45.51123, 8.842377],
  LG001: [45.594024, 8.93100099],
  LG002: [45.59604499, 8.92448099],
  LG003: [45.595761, 8.918817],
  LG004: [45.596165, 8.913097],
  LG005: [45.603692, 8.906914],
  LG006: [45.60292299, 8.90827999],
  LG015: [45.59934799, 8.909412],
  LG025: [45.581896, 8.91286099],
  LG029: [45.581543, 8.913208],
  LG051: [45.59582, 8.93617499],
  LG052: [45.599391, 8.94440799],
  LG057: [45.598911, 8.941067],
  LG058: [45.59618299, 8.93647499],
  LG061: [45.58743699, 8.90875099],
  LG066: [45.59962099, 8.910562],
  LG090: [45.593434, 8.908403],
  LG091: [45.59349999, 8.90822599],
  LG112: [45.58895199, 8.921097],
  LG147: [45.59304199, 8.92717999],
  LG150: [45.590253, 8.92224799],
  LG171: [45.594259, 8.930839],
  LG172: [45.596079, 8.92447],
  LG173: [45.59584399, 8.91912399],
  LG332: [45.59014399, 8.89835199],
  LG335: [45.590064, 8.898395],
  LG336: [45.591778, 8.903216],
  LG337: [45.59152499, 8.902503],
  LG508: [45.59371799, 8.924324],
  LG522: [45.60058399, 8.941694],
  LG611: [45.587585, 8.908746],
  LG805: [45.591975, 8.905595],
  LG807: [45.591843, 8.90553999],
  LG990: [45.59506699, 8.91224199],
  LN010: [45.56915999, 9.02708299],
  LN018: [45.57400599, 9.017876],
  LN019: [45.58023699, 9.02564999],
  LN021: [45.58071699, 9.025464],
  LN024: [45.57181699, 9.02086799],
  LN025: [45.574899, 9.02144999],
  LN028: [45.572172, 9.022454],
  LN030: [45.568003, 9.027439],
  LN031: [45.568119, 9.023493],
  LN032: [45.57733099, 9.023921],
  LN033: [45.577363, 9.02460699],
  LN035: [45.57787099, 9.026233],
  LN041: [45.555581, 9.016186],
  LN043: [45.55638299, 9.02633299],
  LN050: [45.56269, 9.028489],
  LN071: [45.555646, 9.01604],
  LN079: [45.570868, 9.02567499],
  LN081: [45.57149299, 9.00956499],
  LN082: [45.567331, 9.00999299],
  LN088: [45.55640199, 9.02621299],
  LN179: [45.57715299, 9.016301],
  LN183: [45.574324, 9.019606],
  LN500: [45.56303, 9.02868499],
  MC010: [45.485634, 8.86998899],
  MC011: [45.48380099, 8.87151999],
  MC020: [45.483553, 8.87193299],
  MC021: [45.48569599, 8.870296],
  MC050: [45.49465699, 8.87364799],
  MC801: [45.481074, 8.873943],
  MC802: [45.48102599, 8.873895],
  MD001: [45.504683, 9.093606],
  MD111: [45.50536899, 9.09335699],
  MG306: [45.46402999, 8.87120999],
  MG401: [45.46845599, 8.89414699],
  MG402: [45.46825699, 8.894081],
  MG501: [45.46476999, 8.87575],
  MG502: [45.46835999, 8.88498999],
  MG559: [45.46084999, 8.85066599],
  MG561: [45.46732999, 8.8799],
  MG601: [45.46970699, 8.88078599],
  MG701: [45.46958881, 8.90046811],
  MG703: [45.46418, 8.87199999],
  MG704: [45.46186399, 8.86923499],
  MG705: [45.460912, 8.85042399],
  MG708: [45.46481, 8.875092],
  MG720: [45.46728999, 8.87954999],
  MG756: [45.46154, 8.86855899],
  MG796: [45.46199099, 8.894172],
  MG797: [45.462457, 8.894225],
  MG798: [45.46617899, 8.89300299],
  MG799: [45.46653999, 8.89278399],
  MG801: [45.4684, 8.8846],
  MG802: [45.46976399, 8.880969],
  MG871: [45.46963396, 8.9010944],
  MG888: [45.45573999, 8.89153999],
  ML002: [45.479822, 9.166935],
  ML003: [45.48566499, 9.15909599],
  ML004: [45.49016999, 9.151041],
  ML005: [45.49318299, 9.144415],
  ML022: [45.47975499, 9.16716299],
  ML023: [45.485701, 9.15937999],
  ML024: [45.48971299, 9.152761],
  ML025: [45.49221, 9.14735299],
  ML111: [45.469365, 9.17611799],
  ML115: [45.470207, 9.17600099],
  ML200: [45.50079899, 9.130743],
  ML801: [45.50130899, 9.13003299],
  MM101: [45.57621499, 8.799982],
  MM102: [45.57735399, 8.80468499],
  MM103: [45.577939, 8.808512],
  MM204: [45.577983, 8.80552099],
  MN001: [45.509352, 8.97323799],
  MN011: [45.509238, 8.97303799],
  MN015: [45.50656, 8.974192],
  MN021: [45.506336, 8.973975],
  MS010: [45.500328, 8.858048],
  MS011: [45.50039199, 8.85811599],
  NR001: [45.55595699, 8.98031999],
  NR005: [45.558875, 8.97447299],
  NR010: [45.55346599, 8.98635299],
  NR011: [45.549406, 8.979787],
  NR012: [45.54417999, 8.974662],
  NR013: [45.548967, 8.96561799],
  NR014: [45.55163399, 8.966525],
  NR015: [45.55608199, 8.971399],
  NR016: [45.555912, 8.974951],
  NR031: [45.548598, 8.992454],
  NR033: [45.55409, 8.96902199],
  NR040: [45.54912099, 8.99176399],
  NR041: [45.55617799, 8.980066],
  NR042: [45.55907699, 8.97418],
  NR045: [45.55393699, 8.98661599],
  NR090: [45.547464, 8.98564899],
  NR101: [45.55157499, 8.96631699],
  NR102: [45.54896599, 8.96537499],
  NR103: [45.54388499, 8.975047],
  NR104: [45.54938399, 8.979893],
  NR150: [45.55414699, 8.96888099],
  NR801: [45.55393699, 8.98661599],
  NR802: [45.550542, 8.991779],
  NS010: [45.54744399, 8.72519099],
  NS011: [45.541693, 8.72663699],
  NS050: [45.54741499, 8.72527299],
  NS099: [45.552526, 8.72655899],
  OC113: [45.55387199, 8.854508],
  OC114: [45.553579, 8.85430399],
  OR001: [45.60193199, 9.021027],
  OR002: [45.59772099, 9.017894],
  OR003: [45.596638, 9.016842],
  OR004: [45.58521, 9.01458199],
  OR011: [45.60187, 9.02117999],
  OR043: [45.596205, 9.01824599],
  OR044: [45.58535399, 9.014823],
  OR047: [45.600538, 9.01737999],
  OR073: [45.58942899, 9.013706],
  OS001: [45.510751, 8.90215699],
  OS011: [45.507085, 8.901285],
  OS021: [45.50800499, 8.88247099],
  OS022: [45.50416799, 8.89993099],
  OS023: [45.50129899, 8.919102],
  OS033: [45.50177999, 8.91871299],
  OS034: [45.50434499, 8.89993099],
  OS035: [45.508521, 8.88069299],
  PB001: [45.56773099, 8.961503],
  PB009: [45.56332899, 8.952083],
  PB011: [45.569123, 8.95995699],
  PB015: [45.56131899, 8.940878],
  PB021: [45.56894899, 8.96308999],
  PB023: [45.55910699, 8.949106],
  PB024: [45.560603, 8.94310999],
  PB059: [45.56855999, 8.96253499],
  PB081: [45.56462499, 8.95652699],
  PB090: [45.55244, 8.94601499],
  PB100: [45.55940299, 8.951461],
  PB101: [45.559155, 8.951433],
  PB701: [45.54749202, 8.94344916],
  PB702: [45.54755213, 8.94415727],
  PG005: [45.511702, 9.01317099],
  PG008: [45.509783, 8.997856],
  PG009: [45.51356299, 9.005866],
  PG030: [45.51474399, 9.00966599],
  PG031: [45.514475, 9.00981699],
  PG055: [45.511725, 9.01324199],
  PG099: [45.51355399, 9.00559399],
  PG100: [45.51035899, 9.002669],
  PG101: [45.511423, 9.00226699],
  PG102: [45.510818, 9.001459],
  PG111: [45.510221, 9.00277399],
  PM001: [45.54395, 9.005638],
  PM002: [45.53480699, 8.99269299],
  PM003: [45.53991199, 8.99661299],
  PM008: [45.53738999, 8.994549],
  PM022: [45.534791, 8.992524],
  PM033: [45.540123, 8.99666999],
  PM041: [45.544361, 9.00411499],
  PM088: [45.537592, 8.99439799],
  PR001: [45.51022099, 9.087274],
  PR002: [45.51821099, 9.07141299],
  PR009: [45.51630599, 9.07490499],
  PR010: [45.508322, 9.091564],
  PR017: [45.508299, 9.09198999],
  PR019: [45.51620699, 9.075401],
  PR041: [45.51104899, 9.08591499],
  PR042: [45.517769, 9.072405],
  RB018: [45.524244, 8.775235],
  RB061: [45.52063299, 8.77845999],
  RB119: [45.52827, 8.77186599],
  RB120: [45.53267899, 8.76499899],
  RB483: [45.53240099, 8.76506099],
  RG001: [45.50596499, 8.96917699],
  RG011: [45.506067, 8.969086],
  RH001: [45.52489799, 9.05010599],
  RH002: [45.52866499, 9.04637699],
  RH003: [45.53267299, 9.03892499],
  RH004: [45.533255, 9.033785],
  RH005: [45.53409099, 9.02757099],
  RH011: [45.53706299, 9.02133999],
  RH016: [45.537021, 9.036355],
  RH022: [45.528786, 9.046496],
  RH023: [45.53287499, 9.03993299],
  RH024: [45.53343099, 9.03291099],
  RH025: [45.534091, 9.027834],
  RH027: [45.524897, 9.049705],
  RH039: [45.53724, 9.02128299],
  RH097: [45.515658, 9.032857],
  RH098: [45.524529, 9.03783199],
  RH099: [45.515631, 9.032739],
  RH100: [45.52431799, 9.04310299],
  RH110: [45.540178, 9.04469499],
  RH116: [45.53741306, 9.03632586],
  RH117: [45.53103699, 9.04403699],
  RH118: [45.530997, 9.044279],
  RH119: [45.54064199, 9.04244899],
  RH121: [45.53606599, 9.021802],
  RH135: [45.52521699, 9.039549],
  RH150: [45.52438149, 9.043752],
  RH200: [45.535865, 9.01725499],
  SD005: [45.48747299, 8.963475],
  SD006: [45.487517, 8.97689899],
  SD012: [45.48764999, 8.96356399],
  SD060: [45.495967, 8.967433],
  SD066: [45.48740699, 8.976849],
  SD085: [45.486896, 8.96770799],
  SD091: [45.48709099, 8.967736],
  SG001: [45.57868599, 8.91522199],
  SG002: [45.576151, 8.91717099],
  SG003: [45.57355, 8.920216],
  SG033: [45.57355999, 8.92029399],
  SG034: [45.576294, 8.918178],
  SG035: [45.57866099, 8.91534699],
  SG050: [45.578124, 8.908849],
  SG182: [45.57567799, 8.909676],
  SG801: [45.574754, 8.90739399],
  SG807: [45.57769899, 8.914109],
  SI003: [45.56842799, 8.99130799],
  SI004: [45.56949699, 8.98777999],
  SI005: [45.567404, 8.98855599],
  SI010: [45.56256999, 8.98170299],
  SI020: [45.56228999, 8.98166599],
  SI033: [45.56940899, 8.990575],
  SI333: [45.56940899, 8.990575],
  SI801: [45.56842799, 8.99130799],
  SV001: [45.59027799, 8.932299],
  SV002: [45.58582799, 8.94347699],
  SV003: [45.58155899, 8.94888499],
  SV005: [45.58769, 8.94165399],
  SV007: [45.58135199, 8.94923299],
  SV011: [45.590524, 8.93747399],
  SV018: [45.59045299, 8.937346],
  SV022: [45.58607499, 8.943306],
  SV100: [45.59034999, 8.932386],
  TB050: [45.53638599, 8.734837],
  TB051: [45.526626, 8.73109899],
  TB055: [45.530737, 8.749725],
  TB078: [45.53092099, 8.749709],
  TB079: [45.52955199, 8.73839899],
  TB080: [45.52662999, 8.73094199],
  TB081: [45.536463, 8.73483],
  TB090: [45.529568, 8.738624],
  TI033: [45.48631, 8.92275999],
  TI111: [45.48102999, 8.91653099],
  TI211: [45.480971, 8.917234],
  TI333: [45.48613999, 8.92283999],
  TM005: [45.488485, 9.05546099],
  TM006: [45.48880199, 9.054247],
  TM015: [45.48874999, 9.05954099],
  TM035: [45.48840499, 9.06574699],
  TM036: [45.48855199, 9.063887],
  VC005: [45.56663899, 8.89578699],
  VC006: [45.565589, 8.891737],
  VC050: [45.56605299, 8.89069799],
  VC051: [45.567602, 8.89502699],
  VC801: [45.56291299, 8.88946399],
  VC807: [45.563009, 8.889423],
  VH237: [45.495721, 9.04391299],
  VH238: [45.495924, 9.04396199],
  VL037: [45.56247699, 8.99914299],
  VN101: [45.57986899, 8.778765],
  VN102: [45.578992, 8.783912],
  VN103: [45.578474, 8.786486],
  VN201: [45.57863999, 8.786555],
  VN202: [45.579147, 8.78399199],
  VN203: [45.580193, 8.779178],
  VP005: [45.530498, 8.940369],
  VP009: [45.530555, 8.94023],
  VS005: [45.54375, 8.952193],
  VS010: [45.54051299, 8.95076299],
  VT010: [45.491518, 8.94716899],
  VT011: [45.489348, 8.95951199],
  VT018: [45.48522, 8.961061],
  VT022: [45.483388, 8.95361799],
  VT028: [45.485086, 8.95969399],
  VT030: [45.49096599, 8.943608],
  VT100: [45.49156899, 8.94675999],
  VT111: [45.489547, 8.95853499],
  VT222: [45.483443, 8.953661],
  VZ001: [45.52375799, 8.98924199],
  VZ002: [45.526811, 8.997172],
  VZ004: [45.52482, 8.99277399],
  VZ011: [45.523676, 8.988975],
  VZ033: [45.527477, 8.99903],
  VZ999: [45.5240872, 8.98955018]
};

// Line colors for map markers and legend
export const LINE_COLORS = {
  Z601: "#f97316",
  Z602: "#ef4444",
  Z603: "#dc2626",
  Z606: "#b91c1c",
  Z611: "#8b5cf6",
  Z612: "#7c3aed",
  Z616: "#6366f1",
  Z617: "#4f46e5",
  Z618: "#3b82f6",
  Z619: "#64748b",
  Z620: "#059669",
  Z621: "#10b981",
  Z622: "#34d399",
  Z625: "#f59e0b",
  Z627: "#22d3ee",
  Z636: "#a855f7",
  Z641: "#ec4899",
  Z642: "#14b8a6",
  Z643: "#84cc16",
  Z644: "#06b6d4",
  Z646: "#f472b6",
  Z647: "#a78bfa",
  Z649: "#22d3ee",
  Z6C3: "#94a3b8"
};
